import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ShieldCheck, Github, Twitter, Linkedin, 
  Heart, Lock, MapPin
} from 'lucide-react';
import FoxLogo from './FoxLogo';

// 🔥 DİL ENTEGRASYONU 🔥
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const year = new Date().getFullYear();
  const { t } = useLanguage(); // Dil fonksiyonunu al

  return (
    <footer className="w-full bg-white dark:bg-[#0f172a] border-t border-slate-200 dark:border-slate-800 pt-16 pb-8 transition-colors duration-500 font-sans">
      <div className="max-w-[1600px] mx-auto px-6">
        
        {/* MAIN GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* 1. BRAND COLUMN */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
               <div className="bg-gradient-to-br from-orange-600 to-orange-500 p-2 rounded-xl shadow-lg shadow-orange-600/20">
                 <FoxLogo size={24} className="text-white" />
               </div>
               <span className="text-xl font-black tracking-tighter uppercase italic text-slate-900 dark:text-white">
                 Büro<span className="text-orange-600">Fuchs</span>
               </span>
            </div>
            <p className="text-sm text-slate-500 dark:text-slate-400 font-medium leading-relaxed max-w-xs">
              {t('footer_desc') || "Your AI-powered dashboard for financial freedom in Germany. Secure, Fast, Intelligent."}
            </p>
            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-emerald-600 dark:text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full w-fit">
              <ShieldCheck size={12} /> {t('gdpr_compliant') || 'GDPR / DSGVO Compliant'}
            </div>
          </div>

          {/* 2. PRODUCT LINKS */}
          <div>
            <h4 className="text-sm font-black text-slate-900 dark:text-white uppercase tracking-widest mb-6">{t('footer_platform') || 'Platform'}</h4>
            <ul className="space-y-3 text-sm text-slate-500 dark:text-slate-400 font-medium">
              <li><Link to="/dashboard" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('dashboard') || 'Dashboard'}</Link></li>
              <li><Link to="/archive" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('my_archive') || 'Digital Archive'}</Link></li>
              <li><Link to="/salary-calculator" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('salary_calculator') || 'Salary Calculator'}</Link></li>
              <li><Link to="/create-invoice" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('create_invoice') || 'Create Invoice'}</Link></li>
            </ul>
          </div>

          {/* 3. RESOURCES LINKS */}
          <div>
            <h4 className="text-sm font-black text-slate-900 dark:text-white uppercase tracking-widest mb-6">{t('footer_resources') || 'Resources'}</h4>
            <ul className="space-y-3 text-sm text-slate-500 dark:text-slate-400 font-medium">
              <li><Link to="/academy" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('academy_title') || 'Academy'}</Link></li>
              <li><Link to="/official-procedures" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('official_procedures') || 'Official Procedures'}</Link></li>
              <li><Link to="/templates" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('templates_title') || 'Templates'}</Link></li>
            </ul>
          </div>

          {/* 4. LEGAL & CONTACT */}
          <div>
            <h4 className="text-sm font-black text-slate-900 dark:text-white uppercase tracking-widest mb-6">{t('footer_company') || 'Company'}</h4>
            <ul className="space-y-3 text-sm text-slate-500 dark:text-slate-400 font-medium">
              <li><Link to="/privacy" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors flex items-center gap-2"><Lock size={12}/> {t('footer_legal') || 'Privacy & GDPR'}</Link></li>
              <li><Link to="/impressum" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('footer_impressum') || 'Imprint'}</Link></li>
              <li><Link to="/settings" className="hover:text-orange-600 dark:hover:text-orange-500 transition-colors">{t('footer_settings') || 'Settings & Subscription'}</Link></li>
            </ul>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="pt-8 border-t border-slate-200 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="space-y-1 text-center md:text-left">
             <p className="text-xs text-slate-400 font-medium flex items-center justify-center md:justify-start gap-1">
               © {year} BüroFuchs Digital. {t('made_with_love') || 'Made with ❤️ in Frankfurt.'}
             </p>
             <p className="text-[10px] text-slate-400/60 font-mono flex items-center justify-center md:justify-start gap-1">
               <MapPin size={10} /> {t('server_loc') || 'Server Location: Frankfurt (AWS EU-Central-1)'}
             </p>
          </div>

          <div className="flex items-center gap-6">
            <a href="#" className="text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"><Twitter size={18} /></a>
            <a href="#" className="text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"><Github size={18} /></a>
            <a href="#" className="text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"><Linkedin size={18} /></a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;